import '../../css/common.animations.css';
import '../../css/common.colors.scss';
import '../../css/common.displayModes.colors.scss';
import '../../css/common.fonts.css';
import bp from './bp.js';
let engine = {
    animations: {
        pulse: {
            single: 'singlePulse',
            fewPulses: 'fewPulses',
            constantPulse: 'constantPulse'
        },
        fadeIn: "fadeIn",
        reappear: "reappear",
        fadeOut: "fadeOut"
    }
}

engine.supportedThemes = {
    Light: 'light',
    Dark: 'dark'
};

/**
 * Azure Maps Web SDK supported styles
 * {@https://learn.microsoft.com/en-us/azure/azure-maps/supported-map-styles }
 */
engine.supportedStyles = [
    "blank",
    "grayscale_dark",
    "road",
    "night",
    "satellite",
    "satellite_road_labels",
    "road_shaded_relief",
    "high_contrast_dark",
    "high_contrast_light"
];

engine.defaultTheme = engine.supportedThemes.Light;

/**
 * Builds CSS class from supplied name.
 * Ensures animation is known.
 * @param {string} animationName to be mapped on CSS class.
 * @returns animation class known to css layer.
 */
engine.getAnimationCss = (animationName) => `${animationName}Animation`;

engine.wrapIntoCssAnimation = (htmlContent, animation) => {
    let animationCss = engine.getAnimationCss(animation);
    return bp.wrap(htmlContent, animationCss);
};

engine.hideCss = 'hidden';

const hide = engine.hide = elem =>
    Array.isArray(elem)
        ? elem.forEach(item => hide(item))
        : elem.classList.add(engine.hideCss);

const toggleLayers = (layers, visible) =>
    Array.isArray(layers)
        ? layers.forEach(layer => toggleLayers(layer, visible))
        : layers?.setOptions({ visible });

engine.hideLayers = layers => toggleLayers(layers, false);
engine.showLayers = layers => toggleLayers(layers, true);

const show = engine.show = elem =>
    Array.isArray(elem)
        ? elem.forEach(item => show(item))
        : elem.classList.remove(engine.hideCss);

const themePrefix = 'th-';
const stylePrefix = 'st-';

const updateBodyStyles = (value, values, prefix, assert) => {
    if (!value || values.includes(value)) {
        const classList = document.body.classList;
        classList.forEach(className => {
            if (className.startsWith(prefix)) {
                classList.remove(className);
            }
        });
        if (!!value)
            classList.add(`${prefix}${value}`);
    } else if (assert) {
        const known = values.join(', ');
        throw new Error(`${value} is not known, supported are ${known}`);
    }
}

/**
 * Sets one of the supported themes for page.
 * @param {string} theme 
 */
engine.setTheme = (theme) => updateBodyStyles(theme, Object.values(engine.supportedThemes), themePrefix, true);
engine.setMapStyle = (mapStyle) => updateBodyStyles(mapStyle, engine.supportedStyles, stylePrefix);


engine.getCurrentTheme = () =>
    Array
        .from(document.body.classList)
        .find(className => className.startsWith(themePrefix))
        ?.replace(themePrefix, '') ?? null;

export default engine;